<template>
    <div class="pricing-view">
        <section class="page-header py-5 bg-light">
            <div class="container">
                <h1 class="display-5 fw-bold">Cennik usług</h1>
                <p class="lead">Przejrzyste zasady współpracy i indywidualne podejście do każdego klienta.</p>
            </div>
        </section>

        <section class="pricing-content py-5">
            <div class="container">
                <div class="row mb-5">
                    <div class="col-lg-8">
                        <h2 class="mb-4">Elastyczne warunki współpracy</h2>
                        <p>W Selam Rachunkowość oferujemy indywidualne podejście do każdego klienta. Ceny naszych usług
                            są dostosowane do specyfiki Twojej działalności, jej wielkości oraz wybranego zakresu usług.
                        </p>
                    </div>
                </div>

                <div class="pricing-highlight mb-5 p-4 bg-light rounded">
                    <div class="row align-items-center">
                        <div class="col-md-8">
                            <h3 class="mb-3">Ceny są ustalane indywidualnie dla każdego klienta</h3>
                            <p class="mb-0">Aby otrzymać szczegółową wycenę dostosowaną do potrzeb Twojej firmy,
                                zachęcamy do bezpośredniego kontaktu z naszym zespołem. Przeprowadzimy dokładną analizę
                                potrzeb i przygotujemy ofertę idealnie dopasowaną do Twojej działalności.</p>
                        </div>
                        <div class="col-md-4 text-center text-md-end mt-4 mt-md-0">
                            <a href="tel:+48571464177" class="btn btn-primary btn-lg">
                                <i class="fas fa-phone me-2"></i>Zadzwoń teraz
                            </a>
                        </div>
                    </div>
                </div>

                <!-- <div class="row mb-5">
                    <div class="col-lg-12">
                        <h3 class="mb-4">Przykładowe zakresy usług</h3>
                    </div>

                    <div class="col-md-4 mb-4">
                        <div class="pricing-card h-100">
                            <div class="pricing-header text-center p-4">
                                <h4>Ryczałt ewidencjonowany</h4>
                                <div class="pricing-description">Dla mikro przedsiębiorców</div>
                            </div>
                            <div class="pricing-body p-4">
                                <ul class="pricing-features">
                                    <li><i class="fas fa-check text-success me-2"></i>Prowadzenie ewidencji przychodów
                                    </li>
                                    <li><i class="fas fa-check text-success me-2"></i>Rozliczenia podatku ryczałtowego
                                    </li>
                                    <li><i class="fas fa-check text-success me-2"></i>Deklaracje VAT (opcjonalnie)</li>
                                    <li><i class="fas fa-check text-success me-2"></i>Podstawowe doradztwo podatkowe
                                    </li>
                                </ul>
                            </div>
                            <div class="pricing-footer p-4 text-center">
                                <div class="pricing-note">Cena ustalana indywidualnie</div>
                                <router-link to="/kontakt" class="btn btn-outline-primary mt-3">Zapytaj o
                                    wycenę</router-link>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-4">
                        <div class="pricing-card h-100">
                            <div class="pricing-header text-center p-4">
                                <h4>Księga przychodów i rozchodów</h4>
                                <div class="pricing-description">Dla małych i średnich firm</div>
                            </div>
                            <div class="pricing-body p-4">
                                <ul class="pricing-features">
                                    <li><i class="fas fa-check text-success me-2"></i>Prowadzenie KPiR</li>
                                    <li><i class="fas fa-check text-success me-2"></i>Rozliczenia podatku dochodowego
                                    </li>
                                    <li><i class="fas fa-check text-success me-2"></i>Deklaracje VAT</li>
                                    <li><i class="fas fa-check text-success me-2"></i>JPK</li>
                                    <li><i class="fas fa-check text-success me-2"></i>Rozszerzone doradztwo podatkowe
                                    </li>
                                </ul>
                            </div>
                            <div class="pricing-footer p-4 text-center">
                                <div class="pricing-note">Cena ustalana indywidualnie</div>
                                <router-link to="/kontakt" class="btn btn-outline-primary mt-3">Zapytaj o
                                    wycenę</router-link>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-4">
                        <div class="pricing-card h-100">
                            <div class="pricing-header text-center p-4">
                                <h4>Pełna księgowość</h4>
                                <div class="pricing-description">Dla spółek i większych firm</div>
                            </div>
                            <div class="pricing-body p-4">
                                <ul class="pricing-features">
                                    <li><i class="fas fa-check text-success me-2"></i>Prowadzenie ksiąg rachunkowych
                                    </li>
                                    <li><i class="fas fa-check text-success me-2"></i>Rozliczenia podatku CIT</li>
                                    <li><i class="fas fa-check text-success me-2"></i>Sprawozdania finansowe</li>
                                    <li><i class="fas fa-check text-success me-2"></i>Deklaracje VAT i JPK</li>
                                    <li><i class="fas fa-check text-success me-2"></i>Obsługa kadrowo-płacowa</li>
                                    <li><i class="fas fa-check text-success me-2"></i>Kompleksowe doradztwo</li>
                                </ul>
                            </div>
                            <div class="pricing-footer p-4 text-center">
                                <div class="pricing-note">Cena ustalana indywidualnie</div>
                                <router-link to="/kontakt" class="btn btn-outline-primary mt-3">Zapytaj o
                                    wycenę</router-link>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="additional-services mb-5">
                    <h3 class="mb-4">Usługi dodatkowe</h3>
                    <div class="row">
                        <div class="col-md-6 mb-4">
                            <div class="service-item p-4 bg-white rounded shadow-sm">
                                <h5><i class="fas fa-users me-2 text-primary"></i>Kadry i płace</h5>
                                <p>Obsługa kadrowo-płacowa może być zamówiona jako oddzielna usługa lub jako
                                    uzupełnienie usług księgowych.</p>
                                <div class="text-end">
                                    <router-link to="/kontakt" class="btn btn-sm btn-outline-primary">Zapytaj o
                                        szczegóły</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 mb-4">
                            <div class="service-item p-4 bg-white rounded shadow-sm">
                                <h5><i class="fas fa-building me-2 text-primary"></i>Reprezentacja przed urzędami</h5>
                                <p>Profesjonalna reprezentacja przed urzędami skarbowymi, ZUS i innymi instytucjami.</p>
                                <div class="text-end">
                                    <router-link to="/kontakt" class="btn btn-sm btn-outline-primary">Zapytaj o
                                        szczegóły</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pricing-cta text-center p-5 bg-light rounded">
                    <h3 class="mb-3">Potrzebujesz indywidualnej wyceny?</h3>
                    <p class="mb-4">Skontaktuj się z nami, aby omówić szczegóły współpracy i otrzymać spersonalizowaną
                        ofertę dostosowaną do potrzeb Twojej firmy.</p>
                    <div class="d-flex justify-content-center gap-3">
                        <router-link to="/kontakt" class="btn btn-primary btn-lg">Wypełnij formularz
                            kontaktowy</router-link>
                        <a href="tel:+48571464177" class="btn btn-outline-primary btn-lg"><i
                                class="fas fa-phone me-2"></i>Zadzwoń do nas</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'PricingView'
}
</script>

<style lang="scss" scoped>
.pricing-view {
    .page-header {
        background-color: #f1f8ff;

        h1 {
            color: var(--primary-color);
        }
    }

    .pricing-highlight {
        background-color: #e9f7ff;
        border-left: 5px solid var(--secondary-color);
    }

    .pricing-card {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s ease, box-shadow 0.3s ease;

        &:hover {
            transform: translateY(-10px);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .pricing-header {
            background-color: var(--primary-color);
            color: white;

            h4 {
                margin-bottom: 0.5rem;
            }

            .pricing-description {
                opacity: 0.8;
                font-size: 0.9rem;
            }
        }

        .pricing-body {
            background-color: white;

            .pricing-features {
                list-style: none;
                padding-left: 0;

                li {
                    padding: 0.5rem 0;
                    border-bottom: 1px dashed #eee;

                    &:last-child {
                        border-bottom: none;
                    }
                }
            }
        }

        .pricing-footer {
            background-color: #f8f9fa;

            .pricing-note {
                font-size: 0.9rem;
                color: #6c757d;
            }
        }
    }

    .service-item {
        height: 100%;
        transition: transform 0.3s ease;

        &:hover {
            transform: translateY(-5px);
        }

        h5 {
            color: var(--primary-color);
        }
    }

    .pricing-cta {
        background-color: #f1f8ff;
        border-radius: 15px;
    }
}
</style>